import React from 'react';

import MessageCard from '../MessageCard/MessageCard';
import styles from './styles.module.scss';

interface Message {
  sender: string;
  timestamp: string;
  message: string;
  isOwnMessage: boolean;
}

interface ConversationProps {
  messages: Message[];
}

const Conversation = ({ messages }: ConversationProps) => {
  return (
    <div className={styles.conversationContainer}>
      {messages.map((msg, index) => (
        <MessageCard
          key={index}
          sender={msg.sender}
          timestamp={msg.timestamp}
          message={msg.message}
          isOwnMessage={msg.isOwnMessage}
        />
      ))}
    </div>
  );
};

export default Conversation; 